<template>
  <div class="gridBox">
    <van-grid column-num="2">
      <van-grid-item>
        <div class="item">
          <div class="title">关联事前申请单</div>
          <van-cell is-link @click="showPopup">请选择</van-cell>
        </div>
      </van-grid-item>
      <van-grid-item>
        <div class="item">
          <div class="title">金额</div>
          <span style="color: rgb(109, 113, 132)">—</span>
        </div>
      </van-grid-item>
    </van-grid>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",
    };
  },
  methods: {
    showPopup() {
      this.$emit("showPopup", "");
    },
  },
};
</script>

<style>
</style>